import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { ChevronDownIcon, ChevronUpIcon, BugAntIcon } from "@heroicons/react/20/solid";

const isDebugMode = process.env.REACT_APP_DEBUG_MODE === "true" || process.env.NODE_ENV === "development";

const ClaimsDebugPanel: React.FC = () => {
  const { claims, user, activeRole, availableRoles } = useAuth();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isDebugMode) {
    return null;
  }

  return (
    <div className="fixed z-50 bottom-4 right-4">
      <div className="overflow-hidden border rounded-lg shadow-lg bg-zinc-900 border-zinc-700 max-w-md">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center justify-between w-full gap-2 px-3 py-2 text-xs font-medium text-left text-zinc-300 hover:bg-zinc-800"
        >
          <span className="flex items-center gap-2">
            <BugAntIcon className="size-4 text-amber-500" />
            Claims Debug
          </span>
          {isExpanded ? (
            <ChevronDownIcon className="size-4" />
          ) : (
            <ChevronUpIcon className="size-4" />
          )}
        </button>

        {isExpanded && (
          <div className="p-3 space-y-3 text-xs border-t border-zinc-700 max-h-96 overflow-y-auto">
            <div>
              <div className="mb-1 font-medium text-zinc-400">User</div>
              <div className="font-mono text-zinc-300">
                {user?.uid || "Not logged in"}
              </div>
              <div className="font-mono text-zinc-500 text-[10px]">
                {user?.email}
              </div>
            </div>

            <div>
              <div className="mb-1 font-medium text-zinc-400">Active Role</div>
              <div className="font-mono text-green-400">{activeRole || "none"}</div>
            </div>

            <div>
              <div className="mb-1 font-medium text-zinc-400">Available Roles</div>
              <div className="font-mono text-zinc-300">
                {availableRoles.length > 0 ? availableRoles.join(", ") : "none"}
              </div>
            </div>

            <div>
              <div className="mb-1 font-medium text-zinc-400">Custom Claims</div>
              <pre className="p-2 overflow-x-auto font-mono rounded bg-zinc-800 text-zinc-300 text-[10px] whitespace-pre-wrap">
                {claims ? JSON.stringify(claims, null, 2) : "null"}
              </pre>
            </div>

            <button
              onClick={() => {
                navigator.clipboard.writeText(JSON.stringify(claims, null, 2));
              }}
              className="w-full px-2 py-1 text-xs font-medium rounded bg-zinc-700 text-zinc-300 hover:bg-zinc-600"
            >
              Copy Claims to Clipboard
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClaimsDebugPanel;
